import { fetchApi } from "lib/actions/fetcher";
import { endpointsAutodesk } from "lib/actions/endpoints/endpointsAutodesk";

export type AutodeskAuthSession = {
  sessionId: string;
  url: string;
};

/**
 * Opens a consent session. The PKCE verifier and the expected `state` stay on
 * the server, so the only thing that travels back here is a session id to
 * quote on completion: nothing secret passes through the browser.
 */
export async function beginAutodeskAuth(
  workspaceId: number,
): Promise<AutodeskAuthSession> {
  const response = await fetchApi(endpointsAutodesk.beginAuth(workspaceId));
  return response.json();
}
